import { render, staticRenderFns } from "./BestCandidateInputV2.vue?vue&type=template&id=0a766988"
import script from "./BestCandidateInputV2.vue?vue&type=script&lang=js"
export * from "./BestCandidateInputV2.vue?vue&type=script&lang=js"
import style0 from "./BestCandidateInputV2.vue?vue&type=style&index=0&id=0a766988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QField,QIcon,QTooltip,QPopupProxy,QInput,QSpinner,QRating,QRadio,QCheckbox});
